export interface ExchangeRateRefDateMappingEntity {
    id?:number,
    customerCode:string,
    docType:string,
    adjType:string,
    exchangeRateRefDateAttr:string,
    adjustment:number|null,
    adjustmentUom?:string|null,
    activeInd:string|null,
    mappingType: string,

    [key:string]: string | number | Date | undefined | null
}

export const EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY:ExchangeRateRefDateMappingEntity = {
    id:0,
    customerCode: "",
    docType: "",
    adjType: "",
    exchangeRateRefDateAttr: "",
    adjustment: null,
    adjustmentUom: "DAY",
    activeInd: 'Y',
    mappingType: "ExchangeRateRefDateMappingEntity"
}